import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable, Subject, of } from "rxjs";
import { RenunciaService } from "../renuncia.service";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { takeUntil } from "rxjs/operators";
import { DadosRenunciar } from "src/app/model/dados-renunciar";
import { ModalidadeService } from "src/app/shared/services/modalidade.service";

@Component({
    selector: 'app-renuncia-cadastro',
    templateUrl: './renuncia-cadastro.component.html',
    standalone: false
})
export class RenunciaCadastroComponent implements OnInit, OnDestroy {

  renunciaFormGroup: FormGroup;
  garantiaRenunciaFormGroup: FormGroup;
  private readonly destroy$ = new Subject();
  cnpjUsuario: string;
  podeSalvar: boolean = false;
  textoTermoRemuneracaoCoberturaMaxima: string;
  @ViewChild('mensagemTermoRenuncia') mensagemTermoRenuncia: TemplateRef<any>;
  @ViewChild('botoesTermosRenuncia') botoesTermosRenuncia: TemplateRef<any>;
  checkCiencia: boolean = false;
  carregandoCnpj = true;
  calculadoValores: boolean = false;

  constructor(
    private router: Router,
    formBuilder: FormBuilder,
    private renunciaService: RenunciaService,
    private bnLoadingService: BnLoadingService,
    private bnAlertsService: BnAlertsService,
    private bnUsuarioService: BnUsuarioService,
    private modalidadeService: ModalidadeService,
    private modalService: BnModalMessageService,
  ) {
    this.garantiaRenunciaFormGroup = formBuilder.group({
      valorComprometidoPeloFundo: [null, Validators.required],
      valorMaximoASerRenunciadoParaDescomprometer: [null, Validators.required],
      valorDescomprometidoNovasContratacoes: [null, Validators.required],
      acrescimoExclusivoAoLimiteRenunciante: [null, Validators.required],
      acrescimoAoLimiteTodosAgentes: [null, Validators.required],
      ldcStopLossAposRenuncia: [null, Validators.required],
      valorRenunciado: [null, Validators.required, (control): Observable<ValidationErrors | null> => {
        const valorRenunciado = Number(control.value);
        const valorMaximoDisponivel = Number(this.garantiaRenunciaFormGroup.get('valorMaximoASerRenunciadoParaDescomprometer').value);
        if (valorRenunciado > valorMaximoDisponivel) {
          return of({ valorRenunciadoMaiorQuePermitido: true });
        }
        return of(null);
      }],
      idProtocoloArquivoASerSubstituido: null,
    });
    this.renunciaFormGroup = formBuilder.group({
      valorComprometidoPeloFundo: [null, Validators.required],
      valorMaximoASerRenunciadoParaDescomprometer: [null, Validators.required],
      valorRenunciado: [null, Validators.required],
      valorDescomprometidoNovasContratacoes: [null, Validators.required],
      valorParaDistribuicao01: [null, Validators.required],
      valorParaDistribuicao02: [null, Validators.required],
      valorParaDistribuicao03: [null, Validators.required],
      valorParaDistribuicao04: [null, Validators.required],
      valorParaDistribuicao05: [null, Validators.required],
      valorParaDistribuicao06: [null, Validators.required],
      valorParaDistribuicao07: [null, Validators.required],
      valorParaDistribuicao08: [null, Validators.required],
      valorParaDistribuicao09: [null, Validators.required],
    });

    this.garantiaRenunciaFormGroup.get('valorComprometidoPeloFundo').disable();
    this.garantiaRenunciaFormGroup.get('valorDescomprometidoNovasContratacoes').disable();
    this.garantiaRenunciaFormGroup.get('acrescimoExclusivoAoLimiteRenunciante').disable();
    this.garantiaRenunciaFormGroup.get('acrescimoAoLimiteTodosAgentes').disable();
    this.garantiaRenunciaFormGroup.get('ldcStopLossAposRenuncia').disable();
    this.garantiaRenunciaFormGroup.get('valorMaximoASerRenunciadoParaDescomprometer').disable();

    this.renunciaFormGroup.get('valorRenunciado').disable();
    this.renunciaFormGroup.get('valorComprometidoPeloFundo').disable();
    this.renunciaFormGroup.get('valorMaximoASerRenunciadoParaDescomprometer').disable();
    this.renunciaFormGroup.get('valorDescomprometidoNovasContratacoes').disable();

    this.garantiaRenunciaFormGroup.get('valorDescomprometidoNovasContratacoes')
      .valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => this.renunciaFormGroup.get('valorRenunciado').setValue(value));
  }

  totalDistribuicao() {
    const {
      valorParaDistribuicao01,
      valorParaDistribuicao02,
      valorParaDistribuicao03,
      valorParaDistribuicao04,
      valorParaDistribuicao05,
      valorParaDistribuicao06,
      valorParaDistribuicao07,
      valorParaDistribuicao08,
      valorParaDistribuicao09
    } = this.renunciaFormGroup.value;

    const valores = [valorParaDistribuicao01,
      valorParaDistribuicao02,
      valorParaDistribuicao03,
      valorParaDistribuicao04,
      valorParaDistribuicao05,
      valorParaDistribuicao06,
      valorParaDistribuicao07,
      valorParaDistribuicao08,
      valorParaDistribuicao09];

    let total = valores.filter(val => val != null && val != undefined)
      .map(val =>  Number(val))
      .reduce((acc, curr) => acc + curr, 0);

    total = (total * 1000) / 1000;
    return total;
  }

  totaisAcrescimos50() {
    return this.totalDistribuicao() / 2;
  }

  ngOnInit(): void {
    this.bnUsuarioService.usuario$
      .pipe(takeUntil(this.destroy$))
      .subscribe(usuario => {
        this.cnpjUsuario = usuario && usuario.cnpj;
        this.carregandoCnpj = false;
      });
    this.modalidadeService.modalidade$
      .pipe(takeUntil(this.destroy$))
      .subscribe(modalidadeSigla => {
        const modalidade = this.modalidadeService.getModalidades().find(m => m.sigla === modalidadeSigla);
        this.textoTermoRemuneracaoCoberturaMaxima = modalidade.textoTermoRemuneracaoCoberturaMaxima;
      });
    this.consultaDadosRenunciar();
  }

  ngOnDestroy(): void {
      this.destroy$.next(undefined);
      this.destroy$.complete();
  }

  valorRenunciadoTemErro(error) {
    const name = 'valorRenunciado';
    return (
      this.garantiaRenunciaFormGroup.controls[name].hasError(error)
    );
  }

  calculaValoresAcrescimos(valorDistribuicao: string) {
    let valorDistribuicaoAtual = this.renunciaFormGroup.get(valorDistribuicao).value;

    if(valorDistribuicaoAtual == null || valorDistribuicaoAtual == undefined) {
      return 0;
    }

    return (valorDistribuicaoAtual / 2).toFixed(2).toString().replace('.',',');
  }

  async consultaDadosRenunciar() {
    try {
      this.bnLoadingService.bloqueiaTela();
      const dadosRenunciar = await this.renunciaService.getDadosRenunciar().toPromise();

      this.garantiaRenunciaFormGroup.get('valorComprometidoPeloFundo').setValue(dadosRenunciar.valorComprometidoPeloFundo);
      this.garantiaRenunciaFormGroup.get('valorMaximoASerRenunciadoParaDescomprometer').setValue(dadosRenunciar.valorMaximoASerRenunciadoParaDescomprometer);
      this.garantiaRenunciaFormGroup.get('idProtocoloArquivoASerSubstituido').setValue(dadosRenunciar.idProtocoloArquivoASerSubstituido);
      this.garantiaRenunciaFormGroup.get('valorRenunciado').enable();
      this.renunciaFormGroup.get('valorDescomprometidoNovasContratacoes').disable();

      // necerrario para dar tempo aplicação conseguir carregar o cnpj do usuário logado em mémoria.
      let contador = 1;
      while(this.carregandoCnpj && contador < 10) {
        await new Promise((resolve, reject) => setTimeout(() => resolve(true), 1000));
        contador += 1;
      }

      if (Number(dadosRenunciar.valorComprometidoPeloFundo) == 0) {
        this.garantiaRenunciaFormGroup.disable();
        //this.renunciaFormGroup.disable();
        this.bnAlertsService.alertaErro('Atenção', `Para o AF ${this.cnpjUsuario} não existe valor disponível para cálculo da renúncia.`);
      }
    } catch(err) {
      console.log('err', err);
      if (!err.Error) {
        this.bnAlertsService.alertaErro('Erro', 'Erro ao carregar dados a renunciar');
      }
      this.garantiaRenunciaFormGroup.get('valorRenunciado').disable();
      this.renunciaFormGroup.get('valorDescomprometidoNovasContratacoes').disable();
    } finally {
      this.bnLoadingService.liberaTela()
    }
  }

  async salvar() {
    this.desistirDoSolicitacaoRenuncia();
     if (this.garantiaRenunciaFormGroup.invalid || this.renunciaFormGroup.invalid) {
      this.garantiaRenunciaFormGroup.markAllAsTouched();
      this.renunciaFormGroup.markAllAsTouched();
      console.log('forms invalido');
      return;
    }

    if (!this.checkCiencia) {
      console.log('checkCiencia', this.checkCiencia);
      return;
    }

    const {
      valorParaDistribuicao01,
      valorParaDistribuicao02,
      valorParaDistribuicao03,
      valorParaDistribuicao04,
      valorParaDistribuicao05,
      valorParaDistribuicao06,
      valorParaDistribuicao07,
      valorParaDistribuicao08,
      valorParaDistribuicao09
    } = this.renunciaFormGroup.value;
    const valorRenunciado = this.garantiaRenunciaFormGroup.get('valorRenunciado').value;
    const valorDescomprometidoNovasContratacoes = this.garantiaRenunciaFormGroup.get('valorDescomprometidoNovasContratacoes').value;

    let total = this.totalDistribuicao();
    if (total.toFixed(2) > valorDescomprometidoNovasContratacoes) {
      this.bnAlertsService.alertaErro('Erro', 'Somatório dos valores para distribuição maior que Valor descomprometido para novas contratações');
      return;
    }

    try {
      this.bnLoadingService.bloqueiaTela();

      const dadosRenunciar: DadosRenunciar = {
        valorParaDistribuicao01,
        valorParaDistribuicao02,
        valorParaDistribuicao03,
        valorParaDistribuicao04,
        valorParaDistribuicao05,
        valorParaDistribuicao06,
        valorParaDistribuicao07,
        valorParaDistribuicao08,
        valorParaDistribuicao09,
        valorRenunciado,
        valorDescomprometidoNovasContratacoes,
        idProtocoloArquivoASerSubstituido: this.garantiaRenunciaFormGroup.value.idProtocoloArquivoASerSubstituido,
        acrescimoExclusivoAoLimiteRenunciante: this.garantiaRenunciaFormGroup.get('acrescimoExclusivoAoLimiteRenunciante').value,
        cnpjAgenteFinanceiro: this.cnpjUsuario
      };

      await this.renunciaService.salvar(this.cnpjUsuario, dadosRenunciar).toPromise()
      this.router.navigate(['renuncia', 'pesquisa']);
      this.bnAlertsService.alertaSucesso('Sucesso', 'Solicitação de renúncia enviada e processada pelo sistema.');
    } catch(err) {
      console.log('err', err);
      if (!err.Error) {
        this.bnAlertsService.alertaErro('Erro', 'Erro ao solicitar renúncia');
      }
    } finally {
      this.checkCiencia = false;
      this.bnLoadingService.liberaTela()
    }

  }

  abrirModalConfirmarSolicitacaoRenuncia() {
    this.modalService.abrir('Termos e condições', null, 'md', this.mensagemTermoRenuncia, this.botoesTermosRenuncia);
  }

  desistirDoSolicitacaoRenuncia() {
    this.modalService.dismiss('abortou solicitação de renúncia');
  }

  removeQuadro() {
    this.calculadoValores = false;
    this.podeSalvar = false;
    this.renunciaFormGroup.get('valorDescomprometidoNovasContratacoes').setValue(0);
  }

  valorComprometidoPeloFundoMaiorQueZero() {
    const valorComprometidoPeloFundo = Number(this.garantiaRenunciaFormGroup.get('valorComprometidoPeloFundo').value) || 0;
    return valorComprometidoPeloFundo > 0;
  }

  valorARenunciarMaiorQueZero() {
    const valorRenunciar = Number(this.garantiaRenunciaFormGroup.get('valorRenunciado').value) || 0;
    return valorRenunciar > 0;
  }

  valorARenunciarMaiorMaximoPermitido() {
    const valorRenunciar = Number(this.garantiaRenunciaFormGroup.get('valorRenunciado').value) || 0;
    const valorMaximoASerRenunciadoParaDescomprometer = Number(this.garantiaRenunciaFormGroup.get('valorMaximoASerRenunciadoParaDescomprometer').value) || 0;
    return valorRenunciar > valorMaximoASerRenunciadoParaDescomprometer;
  }

  async calcularValores() {
    this.calculadoValores = true;
    this.podeSalvar = true;
    const valorRenunciar = Number(this.garantiaRenunciaFormGroup.get('valorRenunciado').value) || 0;
    try {
      this.bnLoadingService.bloqueiaTela();
      const valores = await this.renunciaService.calcularValores(valorRenunciar).toPromise();
      const valorDescomprometimento = valores.valorDescomprometimento;
      if (valorDescomprometimento > 0) {
        const acrescimoExclusivoAoLimiteRenunciante = valores.acrescimoExclusivoAoLimiteRenunciante;
        const acrescimoAoLimiteTodosAgentes = valores.acrescimoAoLimiteTodosAgentes;

        const ldcStopLossAposRenuncia = valores.ldcStopLossAposRenuncia;
        this.garantiaRenunciaFormGroup.get('valorDescomprometidoNovasContratacoes').setValue(valorDescomprometimento);
        this.garantiaRenunciaFormGroup.get('acrescimoExclusivoAoLimiteRenunciante').setValue(acrescimoExclusivoAoLimiteRenunciante);
        this.garantiaRenunciaFormGroup.get('acrescimoAoLimiteTodosAgentes').setValue(acrescimoAoLimiteTodosAgentes);
        this.garantiaRenunciaFormGroup.get('ldcStopLossAposRenuncia').setValue(ldcStopLossAposRenuncia);
        this.renunciaFormGroup.get('valorDescomprometidoNovasContratacoes').setValue(valorDescomprometimento);
      } else {
        this.bnAlertsService.alertaErro('Atenção', 'Caso prossiga com a solicitação de renúncia, não haverá valores a serem acrescidos para o renunciante.');
        this.garantiaRenunciaFormGroup.get('valorDescomprometidoNovasContratacoes').setValue(0);
        this.garantiaRenunciaFormGroup.get('acrescimoExclusivoAoLimiteRenunciante').setValue(0);
        this.garantiaRenunciaFormGroup.get('acrescimoAoLimiteTodosAgentes').setValue(0);
        this.garantiaRenunciaFormGroup.get('ldcStopLossAposRenuncia').setValue(0);
        this.renunciaFormGroup.get('valorDescomprometidoNovasContratacoes').setValue(0);
      }

    } catch (err) {
      console.log('erro ao calcular os valores', err);
      this.bnAlertsService.alertaErro('Erro', 'Erro ao calcular os valores da renúncia.')
    } finally {
      this.bnLoadingService.liberaTela();
    }
  }

}


